import { NewCustomerIcon, SearchIcon, NewOfferIcon, VVLIcon, MailIcon, PotentialIcon, BestsellerIcon, RocketIcon, CalendarIconDetail, ForecastIcon, ActivityIcon, InfoIcon, GoogleIcon, OutlookIcon } from "../../../../shared/margincalculator/components/icons/Icon";
import "./Dashboard.scss";
import logo from "../../../../assets/margincalculator/logo.png";

function Dashboard() {
  return (
    <div className="dashboard">
      <div className="dashboard__header">
        <img className="dashboard__logo" src={logo} alt="Logo" />
        <div>
        <h1>Willkommen zurück!</h1>
        <p className="dashboard__description">
          allenetze.de — Bereit für den nächsten erfolgreichen Abschluss
        </p></div>
      </div>

      <div className="dashboard__calculate">
        <h2>
          Wie möchten Sie <span className="dashboard__calculate__highlight">kalkulieren?</span>
        </h2>
        <p className="dashboard__description">
          Wählen Sie zwischen der detaillierten Einzelkonfiguration oder unseren
          optimierten Best-Practice Lösungen.
        </p>
        <div className="dashboard__actions">
          <div className="dashboard__action-card">
            <div className="dashboard__action-card__icon-wrapper">
              <NewCustomerIcon />
            </div>
            <span className="dashboard__action-card__label">Neuer Kunde</span>
          </div>

          <div className="dashboard__action-card">
            <div className="dashboard__action-card__icon-wrapper">
              <SearchIcon />
            </div>
            <span className="dashboard__action-card__label">Kundensuche</span>
          </div>

          <div className="dashboard__action-card">
            <div className="dashboard__action-card__icon-wrapper">
              <NewOfferIcon />
            </div>
            <span className="dashboard__action-card__label">Neues Angebot</span>
          </div>

          <div className="dashboard__action-card">
            <div className="dashboard__action-card__icon-wrapper">
              <VVLIcon />
            </div>
            <span className="dashboard__action-card__label">VVL-Liste</span>
          </div>
        </div>
      </div>

      <div className="dashboard__overview-section">
        <h2 className="dashboard__overview-title">Überblick</h2>
        <div className="dashboard__overview-grid">
          <div className="dashboard__overview-card">
            <div className="dashboard__overview-card__header">
              <span>Angebote</span>
              <MailIcon />
            </div>
            <div className="dashboard__overview-card__content">
              <div className="dashboard__overview-card__content-icon">
                <RocketIcon />
              </div>
              <h3>Dein Umsatz wartet</h3>
              <p>Starte deinen ersten Deal!</p>
            </div>
          </div>

          <div className="dashboard__overview-card dashboard__overview-card--potential">
            <div className="dashboard__overview-card__header">
              <span>Potenzial</span>
              <PotentialIcon />
            </div>
            <div className="dashboard__overview-card__content">
              <div className="dashboard__overview-card__content-icon">
                <PotentialIcon />
              </div>
              <h3>Potenzial entdecken</h3>
              <p>Versende ein Angebot.</p>
            </div>
          </div>

          <div className="dashboard__overview-card dashboard__overview-card--bestseller">
            <div className="dashboard__overview-card__header">
              <span>Top Tarife</span>
              <BestsellerIcon />
            </div>
            <div className="dashboard__overview-card__content">
              <div className="dashboard__overview-card__content-icon">
                <BestsellerIcon />
              </div>
              <h3>Deine Bestseller</h3>
              <p>Erscheinen hier bald.</p>
            </div>
          </div>
        </div>

        <div className="dashboard__detail-grid">
          {/* Ø Marge */}
          <div className="dashboard__detail-card">
            <div className="dashboard__detail-card__header">
              <div className="dashboard__detail-card__header-left">
                <span>Ø Marge</span>
              </div>
            </div>
            <div className="dashboard__detail-card__body">
              <div className="dashboard__detail-card__main-value">0,00 €</div>
              <div className="dashboard__detail-card__sub-value">
                Diese Woche (0 Angebote)
              </div>
              <div className="dashboard__detail-card__footer">
                Monat: 0,00 €
              </div>
            </div>
          </div>

          {/* Kalender / Nächste Termine */}
          <div className="dashboard__detail-card">
            <div className="dashboard__detail-card__header">
              <div className="dashboard__detail-card__header-left">
                <CalendarIconDetail />
                <span>Kalender</span>
              </div>
            </div>
            <div className="dashboard__detail-card__body">
              <p className="dashboard__detail-card__text-small">
                Keine Termine vorhanden. Erstellen Sie Ihren ersten Termin.
              </p>
              <button className="dashboard__detail-card__btn-full">
                <CalendarIconDetail /> Zum Kalender
              </button>
            </div>
          </div>

          {/* Umsatz-Prognose */}
          <div className="dashboard__detail-card dashboard__detail-card--large">
            <div className="dashboard__detail-card__header">
              <div className="dashboard__detail-card__header-left">
                <div className="dashboard__detail-card__icon-circle dashboard__detail-card__icon-circle--purple">
                  <ForecastIcon />
                </div>
                <div>
                  <div className="dashboard__detail-card__title">
                    Umsatz-Prognose
                  </div>
                  <div className="dashboard__detail-card__subtitle">
                    Q3 2026
                  </div>
                </div>
              </div>
              <div className="dashboard__detail-card__badge">
                Geringe Konfidenz
              </div>
            </div>
            <div className="dashboard__detail-card__body">
              <div className="dashboard__detail-card__main-value">0,00 €</div>
              <div className="dashboard__detail-card__trend">
                — 0% vs. aktuelles Quartal
              </div>

              <div className="dashboard__detail-card__stats-grid">
                <div className="dashboard__detail-card__stat-item">
                  <div className="dashboard__detail-card__stat-label">
                    Pipeline-Wert
                  </div>
                  <div className="dashboard__detail-card__stat-value">
                    0,00 €
                  </div>
                  <div className="dashboard__detail-card__stat-sub">
                    /Monat (offen)
                  </div>
                </div>
                <div className="dashboard__detail-card__stat-item">
                  <div className="dashboard__detail-card__stat-label">
                    Konversionsrate
                  </div>
                  <div className="dashboard__detail-card__stat-value">30%</div>
                  <div className="dashboard__detail-card__stat-sub">
                    der Angebote
                  </div>
                </div>
              </div>

              <div className="dashboard__detail-card__progress-section">
                <div className="dashboard__detail-card__progress-header">
                  <span>Aktuelles Quartal</span>
                  <span>0,00 €</span>
                </div>
                <div className="dashboard__detail-card__progress-bar">
                  <div className="dashboard__detail-card__progress-fill"></div>
                </div>
                <div className="dashboard__detail-card__progress-footer">
                  0 Angebote erstellt
                </div>
              </div>

              <div className="dashboard__detail-card__info-box">
                <InfoIcon />
                <span>
                  Prognose basiert auf Pipeline-Wert, historischer
                  Konversionsrate und aktuellem Quartalstrend. Mehr Daten =
                  höhere Genauigkeit.
                </span>
              </div>
            </div>
          </div>

          {/* Nächste Termine (Large Card) */}
          <div className="dashboard__detail-card dashboard__detail-card--large">
            <div className="dashboard__detail-card__header">
              <div className="dashboard__detail-card__header-left">
                <CalendarIconDetail />
                <span>Nächste Termine</span>
              </div>
              <span className="dashboard__detail-card__header-link">
                Kalender →
              </span>
            </div>
            <div className="dashboard__detail-card__body dashboard__detail-card__body--center">
              <div className="dashboard__detail-card__empty-icon">
                <CalendarIconDetail />
              </div>
              <p className="dashboard__detail-card__text-muted">
                Keine anstehenden Termine
              </p>
              <div className="dashboard__detail-card__connect">
                <span className="dashboard__detail-card__text-label">
                  Kalender verbinden:
                </span>
                <div className="dashboard__detail-card__connect-buttons">
                  <button className="dashboard__detail-card__btn-connect">
                    <GoogleIcon /> Google
                  </button>
                  <button className="dashboard__detail-card__btn-connect">
                    <OutlookIcon /> Outlook
                  </button>
                </div>
              </div>
              <button className="dashboard__detail-card__btn-add-inline">
                + Termin erstellen
              </button>
            </div>
          </div>

          {/* Letzte Aktivitäten */}
          <div className="dashboard__detail-card dashboard__detail-card--large">
            <div className="dashboard__detail-card__header">
              <div className="dashboard__detail-card__header-left">
                <ActivityIcon />
                <span>Letzte Aktivitäten</span>
              </div>
            </div>
            <div className="dashboard__detail-card__body dashboard__detail-card__body--center">
              <div className="dashboard__detail-card__empty-icon">
                <ActivityIcon />
              </div>
              <p>Noch keine Aktivitäten</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
